module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "trans"
  }, [_c('a', {
    attrs: {
      "href": "#/html/03_contents#trans"
    }
  }, [_c('b', [_vm._v("TRANSLATOR’S NOTE:")])])]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At times I have given an English equivalent to some of the French expressions, while on other occasions I exclusively used the French term (example: "), _c('i', [_vm._v("ramener, rassembler.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("La Mise en main")]), _vm._v(" - in hand; bringing the horse in the hand; yielding of the jaw in the position of the "), _c('i', [_vm._v("ramener,")]), _vm._v(" on the bit.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("Le Ramener")]), _vm._v(" - flexing of the poll, with the forehead vertical; entails a degree of collection.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("La Descente de main")]), _vm._v(" - yielding of the hand, finger and/or rein pressure the horse must not change his pace or position; he is in self-carriage.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("La Descente de jambes")]), _vm._v(" - yielding of legs; ceasing the action of legs.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("L’effet d’ensemble")]), _vm._v(" - Combined or coordinated effect; use of the leg and/or spur simultaneously combined with the use of the hand.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("Rassembler, rassemblé")]), _vm._v(" - I have used the French term "), _c('i', [_vm._v("rassembler")]), _vm._v(" exclusively because the English term "), _c('i', [_vm._v("collection")]), _vm._v(" is not quite as accurate, with a more limiting meaning. "), _c('i', [_vm._v("Rassembler")]), _vm._v(" describes the bearing of the horse’s head in the position of the "), _c('i', [_vm._v("ramener")]), _vm._v(" and the hindquarters engaged in collection. When using the term "), _c('i', [_vm._v("rassembler,")]), _vm._v(" while "), _c('i', [_vm._v("collection")]), _vm._v(" is involved, it includes each and every part and action of the horse, the suppleness of his body, his back, legs, the pliancy of his "), _c('i', [_vm._v("ressorts")]), _vm._v(" (that is, “springs,” his joints and muscles, etc.) his ease, harmony, and generosity when moving, the cadence and rhythm of his gaits, and, above all, his lightness. "), _c('i', [_vm._v("Rassembler")]), _vm._v(" implies the collection, the gathering together of the entire horse, the convergence of the horse’s forehand and his hindquarters. It is the all-round perfection of a well schooled horse, which, together with lightness, is the crowning glory of a trainer’s efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "trans_noind"
  }, [_c('i', [_vm._v("Dressage -")]), _vm._v(" Used only to indicate the discipline (schooling of horses and competitive dressage); the English term “schooling” has been used when the actual training of horses is involved.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a380f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_translate.vue
// module id = 72
// module chunks = 0